export const environment = {
  production: false,
  configurationServiceBaseUrl: 'https://flexara.memorail.net/api/configuration',
  productServiceBaseUrl: 'https://flexara.memorail.net/api/product',
  ruleEngineBaseUrl: 'https://flexara.memorail.net/api/rules',
  pricingServiceBaseUrl: 'https://flexara.memorail.net/api/pricing',
  keycloakBaseUrl: 'https://auth.memorail.net',
  keycloakRealm: 'flexara',
  keycloakClientId: 'flexara-frontend',
  defaultProductId: '00000000-0000-0000-0000-000000000001',
  defaultProductVersionId: '00000000-0000-0000-0000-000000000001'
};
